import { useNavigate } from 'react-router-dom';

import { Stack } from '@ekhodealer/ekho-common/rev';

import { TablePageLayout } from '@common/components/TablePageLayout';
import { useCurrentServicesProviderId } from '@common/hooks/useCurrentServicesProviderId';
import ReportsPaymentReconciliationSummary from '@features/reports/components/reports_payment_reconciliation/ReportsPaymentReconciliationSummary';
import ReportsPaymentReconciliationTable from '@features/reports/components/reports_payment_reconciliation/ReportsPaymentReconciliationTable';
import ReportsPaymentReconciliationToolbar from '@features/reports/components/reports_payment_reconciliation/ReportsPaymentReconciliationToolbar';
import { paths } from '@config/paths';

export default function ReportsPaymentsPage() {
	const navigate = useNavigate();
	const servicesProviderId = useCurrentServicesProviderId();

	const handleReportsClick = () => {
		if (servicesProviderId) {
			navigate(paths.reports.getHref(servicesProviderId));
		}
	};

	return (
		<TablePageLayout
			breadcrumb={{
				items: [
					{
						id: 'reports',
						label: 'Reports',
						onActivate: handleReportsClick,
					},
					{
						id: 'payment-reconciliation',
						label: 'Payment reconciliation',
					},
				],
				currentId: 'payment-reconciliation',
			}}
			aboveTableContent={
				<Stack itemsSpacing='16'>
					<ReportsPaymentReconciliationToolbar />
					<ReportsPaymentReconciliationSummary />
				</Stack>
			}
			tableContent={<ReportsPaymentReconciliationTable />}
		/>
	);
}
